import script from "./BaseFormItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFormItem.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFormItem.vue?vue&type=style&index=0&id=16e1720c&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16e1720c"]])

export default __exports__